import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { AssessmentFormService } from '../../services/assessment-form.service';
import { IFormModel } from '../../models/form-model';
import { MatDialogRef } from '@angular/material/dialog';
import { serializeInitialAssessmentForm } from '../../utils/initial-assessment-serialization.util';


@Component({
  selector: 'app-submit-form-dialog',
  templateUrl: './submit-form-dialog.component.html',
  styleUrls: ['./submit-form-dialog.component.scss']
})
export class SubmitFormDialogComponent implements OnInit {

  isSaving = false;
  success = false;
  hasError = false;
  errorMessage = '';

  constructor(private dialogRef: MatDialogRef<SubmitFormDialogComponent>, private assessmentFormService: AssessmentFormService) { }

  ngOnInit() {
    const form = this.assessmentFormService.getForm();
    this.isSaving = true;
    if(form) {
        const data: IFormModel = {
          id: form.loadedFormId,
          username: '',
          pin: '',
          submitted: true,
          formDetails: serializeInitialAssessmentForm(form),
          resumeId: null,
          decisionId: null,
          downloadedToMM: false,
          isDeleted: false
        };
        this.submit(data);
    } else { 
      this.hasError = true;
      this.errorMessage = 'No form data available to submit.';
      this.isSaving = false;
      this.success = false;
    }


  }

  private submit(data: IFormModel) {

    //this form has not been saved previously, just call save form
    if(!data.id) {
      this.assessmentFormService.saveForm(data).subscribe({
        next: () => {
          this.success = true;
          this.isSaving = false;
        },
        error: (error) => {
          this.hasError = true;
          this.errorMessage = error.error?.Message || 'Connection was interrupted';
          this.isSaving = false;
        },
        complete: () => {
          this.isSaving = false;
        }
      });
    } else {
      //id is exists, meaning this form was saved previously, so update form
       this.assessmentFormService.updateForm(data).subscribe({
        next: () => {
          this.success = true;
          this.isSaving = false;
        },
        error: (error) => {
          this.hasError = true;
          this.errorMessage = error.error?.Message || 'Connection was interrupted';
          this.isSaving = false;
        },
        complete: () => {
          this.isSaving = false;
        }
      });

  }
}

   close() {
    
    if (!this.isSaving) {
      this.dialogRef.close(this.success);
    }

  }
  

}